import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider as UrqlProvider } from "urql";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AuthProvider } from "@/features/login/context/AuthContext";
import { NbiFormProvider } from "@/features/nbi/context/NbiFormContext";
import { DOCUMENT_TYPES_CACHE_KEY } from "@/features/schema-management/constants";
import { PostHogProvider } from "./posthog";
import { SonnerProvider } from "./sonner";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

const cachedDocumentTypes = localStorage.getItem(DOCUMENT_TYPES_CACHE_KEY);
if (cachedDocumentTypes) {
    try {
        queryClient.setQueryData(["document-types"], JSON.parse(cachedDocumentTypes));
    } catch {
        localStorage.removeItem(DOCUMENT_TYPES_CACHE_KEY);
    }
}

export function Providers({ children }: { children: React.ReactNode }) {
    return (
        <PostHogProvider>
            <AuthProvider>
                <ThemeProvider>
                    <QueryClientProvider client={queryClient}>
                        <NbiFormProvider>
                            <SonnerProvider />
                            <UrqlProvider value={{} as any}>{children}</UrqlProvider>
                        </NbiFormProvider>
                    </QueryClientProvider>
                </ThemeProvider>
            </AuthProvider>
        </PostHogProvider>
    );
}
